module.exports = __webpack_public_path__ + "static/media/webIcons-35.5e055cf3.svg";